import React, { useMemo, useState } from 'react';
import Label from '../../../../components/svg/Label';
import { analyticsTrack } from '../../../../helpers/AnalyticsUtility';
import { getHexColorString, getOpacityFromRgba, getRgba } from '../../../../helpers/helpers';
import { AudioValue, ValueChangedForFieldFunc } from '../../../formeditor-types';
import { convertSecondsToTime } from '../../../helpers';
import AudioModal from '../../Editors/AudioModal';
import FieldWrapper from './FieldWrapper';

export type AudioFieldProps = {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor?: TypeMePlease;
  backgroundColor?: TypeMePlease;
  editable: boolean;
  value?: string;
  maxLength?: number;
  name?: string;
  fontName?: string;
  fontSize?: number;
  formId?: string;
  tabIndex?: number;
};

export default function AudioField(props: AudioFieldProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const parsedValue: AudioValue = useMemo(() => (props.value ? JSON.parse(props.value) : null), [props.value]);

  const mouseDown = () => {
    setModalOpen(true);
    //Trigger: User opens an audio field on a form.
    analyticsTrack('Audio Capture Field - Opened', {});
  };

  return (
    <FieldWrapper
      onMouseDown={() => mouseDown()}
      x={props.x}
      y={props.y}
      w={props.w}
      h={props.h}
      backgroundColor={props.editable ? props.backgroundColor : getRgba('#ffffff', 0)}
      editable
      id={props.id}
      fieldId={props.fieldId}
    >
      <Label
        text={parsedValue ? `${convertSecondsToTime(parsedValue.length)} - ${parsedValue.name}` : ''}
        width={props.w}
        align={props.align}
        fontName={props.fontName}
        fontSize={props.fontSize}
        foregroundColor={getHexColorString(props.foregroundColor)}
        foregroundColorOpacity={getOpacityFromRgba(props.foregroundColor)}
      />
      {modalOpen && (
        <AudioModal
          name={props.name}
          onClose={() => setModalOpen(false)}
          maxLength={props.maxLength}
          value={parsedValue}
          valueUpdated={props.valueUpdated}
          editable={props.editable}
          formId={props.formId}
          fieldId={props.fieldId}
        />
      )}
    </FieldWrapper>
  );
}
